// Voeg hier je eigen custom JavaScript toe. Let op: Gebruik geen jQuery, maar vanilla JavaScript.

document.addEventListener('DOMContentLoaded', function () {



    // 2. FANCYBOX INTEGRATIE (Met vertraging om WP voor te zijn)
    setTimeout(() => {
        document.querySelectorAll('.gallery__container figure').forEach((figure) => {
            const img = figure.querySelector('img');
            if (!img) return;

            // Als de afbeelding al in een link zit (van WP), halen we de afbeelding eruit
            const existingLink = figure.querySelector('a');
            if (existingLink) {
                existingLink.parentNode.insertBefore(img, existingLink);
                existingLink.remove();
            }

            // Maak de nieuwe Fancybox link
            const link = document.createElement('a');
            link.href = img.getAttribute('src');
            link.setAttribute('data-fancybox', 'gallery');
            link.setAttribute('data-caption', img.alt || '');
            link.style.cursor = 'zoom-in';

            img.parentNode.insertBefore(link, img);
            link.appendChild(img);
        });

        // Initialiseer Fancybox
        if (typeof Fancybox !== "undefined") {
            Fancybox.bind("[data-fancybox='gallery']", {
                Thumbs: { autoStart: true },
                Toolbar: { display: ["zoom", "close"] },
                infinite: true
            });
        }
    }, 100);

    // 3. COUNTERS
    const counters = document.querySelectorAll('.cijfers-call h2');
    const startCounting = (entries, observer) => {
        entries.forEach(entry => {
            if (entry.isIntersecting) {
                const counter = entry.target;
                const target = parseInt(counter.innerText.replace(/[^0-9]/g, ''));
                if (isNaN(target)) return;

                const duration = 2500;
                const startTime = performance.now();

                const updateCount = (currentTime) => {
                    const elapsedTime = currentTime - startTime;
                    let progress = Math.min(elapsedTime / duration, 1);
                    const easeOutProgress = 1 - Math.pow(1 - progress, 3);
                    const currentCount = Math.floor(easeOutProgress * target);
                    counter.innerText = currentCount.toLocaleString('nl-NL');

                    if (progress < 1) {
                        requestAnimationFrame(updateCount);
                    } else {
                        counter.innerText = target.toLocaleString('nl-NL');
                    }
                };
                requestAnimationFrame(updateCount);
                observer.unobserve(counter);
            }
        });
    };

    const counterObserver = new IntersectionObserver(startCounting, { threshold: 0.2 });
    counters.forEach(counter => counterObserver.observe(counter));

const handleGalleryMore = () => {
    console.log("Gallery script gestart...");
    
    const containers = document.querySelectorAll('.gallery__container');
    console.log("Aantal containers gevonden:", containers.length);

    containers.forEach((container, index) => {
        const figures = container.querySelectorAll('figure');
        console.log(`Container ${index} heeft ${figures.length} afbeeldingen.`);

        if (figures.length > 5) {
            const moreCount = figures.length - 5;
            const fifthFigure = figures[4];
            const fifthLink = fifthFigure.querySelector('a');

            if (fifthLink) {
                // 1. Voeg de class toe aan de figure
                fifthFigure.classList.add('gallery__more');
                
                // 2. Verwijder een eventuele oude div (voorkomt duplicaten)
                const existing = fifthLink.querySelector('.gallery__number');
                if (existing) existing.remove();

                // 3. Maak de nieuwe div aan
                const numberDiv = document.createElement('div');
                numberDiv.className = 'gallery__number';
                numberDiv.textContent = `+${moreCount}`;
                
                // 4. Injecteer in de link
                fifthLink.appendChild(numberDiv);
                
                console.log("Succes: +", moreCount, "toegevoegd aan de link.");
            } else {
                console.error("Fout: Geen <a> tag gevonden in de vijfde figure.");
            }
        }
    });
};
setTimeout(() => {
  document.querySelectorAll('.gallery__container').forEach(container => {
    // Verwijder eerst oude tellers als die er staan (handig bij resize)
    const existingBadge = container.querySelector('.gallery__number');
    if (existingBadge) existingBadge.remove();

    const items = container.querySelectorAll('figure');
    
    // Check: kleiner dan 600px = 4 items, anders 5 items
    // (Pas de 4 en 5 hieronder aan als je het andersom bedoelde)
    const limit = window.innerWidth < 600 ? 4 : 5;
    
    if (items.length > limit) {
      const moreCount = items.length - limit;
      const targetItem = items[limit - 1].querySelector('a');

      if (targetItem) {
        targetItem.classList.add('gallery__more');

        const numberDiv = document.createElement('div');
        numberDiv.classList.add('gallery__number');
        numberDiv.textContent = '+' + moreCount;

        targetItem.appendChild(numberDiv);
      }

      // VERBERG de items die boven de limiet vallen
      items.forEach((item, index) => {
        if (index >= limit) {
          item.style.display = 'none';
        } else {
          item.style.display = 'block'; // of 'flex'/'grid' afhankelijk van je layout
        }
      });
    }
  });
}, 250);

// Start het script zodra de pagina en de WP scripts klaar zijn
window.addEventListener('load', handleGalleryMore);

    // 5. SCROLL HEADER
    window.addEventListener("scroll", function () {
        if (window.scrollY > 200) {
            document.body.classList.add("scrolled");
        } else {
            document.body.classList.remove("scrolled");
        }
    });

    // Zoek alle knoppen die een YouTube link bevatten
  const videoLinks = document.querySelectorAll('a[href*="youtube.com/watch"], a[href*="youtu.be/"]');

  videoLinks.forEach(link => {
    // Voeg het data-attribuut toe dat Fancybox activeert
    link.setAttribute('data-fancybox', 'gallery');
  });
});

window.addEventListener('load', () => {
    const lightboxContainers = document.querySelectorAll('.wp-lightbox-container');

    lightboxContainers.forEach(container => {
        // Verwijder de Interactivity API controle
        container.removeAttribute('data-wp-interactive');
        container.removeAttribute('data-wp-context');
        container.classList.remove('wp-lightbox-container');

        const img = container.querySelector('img');
        if (img) {
            img.removeAttribute('data-wp-on-async--click');
            img.removeAttribute('data-wp-init');
            img.style.cursor = 'pointer';
        }

        const button = container.querySelector('.lightbox-trigger');
        if (button) {
            button.remove();
        }

        const link = container.querySelector('a');
        if (link) {
            link.style.cursor = 'pointer';
        }
    });
});

// const observer = new MutationObserver(() => {
//     document.querySelectorAll('.wp-lightbox-container').forEach(container => {
//         container.removeAttribute('data-wp-interactive');
//         container.removeAttribute('data-wp-context');
//         container.classList.remove('wp-lightbox-container');

//         const img = container.querySelector('img');
//         if (img) {
//             img.removeAttribute('data-wp-on-async--click');
//             img.removeAttribute('data-wp-init');
//             img.style.cursor = 'pointer';
//         }

//         const button = container.querySelector('.lightbox-trigger');
//         if (button) button.remove();
//     });
// });

// observer.observe(document.body, {
//     childList: true,
//     subtree: true
// });

